/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { validationFuncByType } from "./validate-question-by-type";
import { validateTitleAndKey } from "./validate-question-title-key";
import { duplicateKeyValidation } from "./validate-duplicate-keys";

/**
 * Checks if a question has both a title and a key
 * @param {Question} question
 */
export const validateQuestion = (question) => {
    const type = question?.type;
    if (!type) {
        throw new Error(`Question requires type: ${JSON.stringify(question)}`);
    }
    // Warning: expected to return undefined for most questions 
    const validationFunc = validationFuncByType[type];
    if (typeof validationFunc === "function") {
        return validationFunc(question);
    }
    return validateTitleAndKey(question);
};


/**
 * 
 * @param {Question[]} questions
 * @returns {*}
 */
export const correlatedValidation = (questions) => {
    return duplicateKeyValidation(questions);
};
